import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { UserOnCompany } from "interfaces";

export class CompanyUserList extends ListStoreConstructor<UserOnCompany> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const paramsWithSort = {
          ...params,
          sort: ["user.statusDate,desc"],
        };
        return services.getCompanyUserList({ companyId: this.id }, paramsWithSort).then(
          (response) =>
            ({
              content: response.content || [],
              size: response.size || 0,
              totalPages: response.totalPages || 0,
              totalElements: response.totalElements || 0,
            }) as any
        );
      },
      {
        pollingInterval: 10000,
        sorters: {
          statusDate: "desc",
        },
      }
    );
  }
}
